import { apiUserProfile } from "../api/userProfileAPI";

const search = async (agentId) => {
  const result = await apiUserProfile.search(agentId)
  return result
}

const downloadAppointmentLetter = async (agentId) => {
  const result = await apiUserProfile.downloadAppointmentLetter(agentId)
  return result
}

export const userProfileBiz = {
  search: search,
  downloadAppointmentLetter: downloadAppointmentLetter,
  // save: save,
  // update: update,
  // getById: getById
}
